import React from 'react';
import moment from 'moment';
import { Clock, Users } from 'lucide-react';
import { ArrowRepeatAllIcon } from '../../../../../modules/default-svg';

export const CalendarEvent = ({ event, OnRedirect ={} }) => {
  const setting = JSON.parse(localStorage.getItem("settings"));
  const timeFormat = setting?.regionalSettings?.timeFormat ? (setting?.regionalSettings?.timeFormat.trim().toLowerCase() === "hh:mm a" ? "h:mm A" : "HH:mm"): "HH:mm";

  const formatTime = () => {
    const start = moment(event.startTime);
    const end = moment(event.endTime);
    
    if (event.isAllDay) {
      return 'All Day';
    }
    
    return `${start.format(timeFormat)} - ${end.format(timeFormat)}`;
  };

  const getDuration = () => {
    if (event.isAllDay) return null;
    
    const start = moment(event.startTime);
    const end = moment(event.endTime);
    const duration = moment.duration(end.diff(start));
    
    if (duration.hours() > 0) {
      return `${duration.hours()}h ${duration.minutes()}m`;
    }
    return `${duration.minutes()}m`;
  };

  const handleRedirection = () => {
    if (OnRedirect) {
      OnRedirect();
    }
  };

  return (
    <div 
      onClick={() =>{handleRedirection()}}
      className={`calendar-event ${event.dateCanceled ? 'calendar-event--canceled' : ''}`}>
      <div className="calendar-event__header">
        <div className="calendar-event__icon">
          <Users />
        </div>
        <div className="calendar-event__title-section">
          <h6 className="calendar-event__title">{event.name}</h6>
          {event.project && (
            <span className="calendar-event__project">{event.project.name}</span>
          )}
        </div>
        <div className="calendar-event__badges">
          {event.isRecurring && (
            <span className="calendar-event__badge calendar-event__badge--recurring">
              <ArrowRepeatAllIcon color={"#FFF"} />
              Recurring
            </span>
          )}
          {event.dateCanceled && (
            <span className="calendar-event__badge calendar-event__badge--canceled">
              Canceled
            </span>
          )}
        </div>
      </div>

      <div className="calendar-event__details">
        <div className="calendar-event__time">
        <span className="inline-flex items-center justify-start gap-1">
          <Clock size={12} /> {formatTime()} {getDuration() && <span className="calendar-event__duration"> ({getDuration()})</span>}
        </span>
        </div>
        
        {event.dateCanceled && (
          <div className="calendar-event__canceled-date">
            <strong>Canceled on:</strong> {moment(event.dateCanceled).format('MMM D, YYYY')}
          </div>
        )}
      </div>
    </div>
  );
};